import React, { createContext, useContext, useState, useCallback } from "react";
import CardSelectorModal from "./CardSelectorModal";

const CardSelectorContext = createContext();

export const useCardSelector = () => useContext(CardSelectorContext);

export const CardSelectorProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [CardComponent, setCardComponent] = useState(null);
  const [title, setTitle] = useState("");
  const [onSelectCallback, setOnSelectCallback] = useState(null);
  const [highlightVersions, setHighlightVersions] = useState([]);
  const [pinNamespace, setPinNamespace] = useState(null);
  const [getId, setGetId] = useState(null);

  const openCardSelector = useCallback((config) => {
    setItems(config.items);
    setCardComponent(() => config.CardComponent);
    setTitle(config.title);
    setOnSelectCallback(() => config.onSelect);
    setIsOpen(true);
    setHighlightVersions(config?.highlightVersions ?? []);
    setPinNamespace(config?.pinNamespace ?? null);
    setGetId(() => config?.getId ?? null);
  }, []);

  const closeCardSelector = useCallback(() => {
    setIsOpen(false);
    setItems([]);
    setCardComponent(null);
    setTitle("");
    setOnSelectCallback(null);
    setPinNamespace(null);
    setGetId(null);
  }, []);

  const handleSelect = useCallback(
    (selectedCard) => {
      if (onSelectCallback) {
        onSelectCallback(selectedCard);
      }
      closeCardSelector();
    },
    [onSelectCallback, closeCardSelector]
  );

  return (
    <CardSelectorContext.Provider
      value={{ openCardSelector, closeCardSelector }}
    >
      {children}
      <CardSelectorModal
        isOpen={isOpen}
        onClose={closeCardSelector}
        onSelect={handleSelect}
        items={items}
        CardComponent={CardComponent}
        title={title}
        highlightVersions={highlightVersions}
        pinNamespace={pinNamespace}
        getId={getId}
      />
    </CardSelectorContext.Provider>
  );
};
